// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#fff","menuActiveText":"#fff","subMenuActiveText":"#ec212d","menuBg":"#fff","menuHover":"#2db0a0","subMenuBg":"#3c3c3d","subMenuHover":"#2db0a0","sideBarWidth":"170px"};